// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.responsive-table-container {
  width: 100%;
  overflow: auto;
  margin-top: 20px;
  height: 50vh;
  scrollbar-width: thin;            /* Firefox */
  scrollbar-color: #888 #f1f1f1;     /* Firefox */
}

/* Chrome, Edge, Safari */
.responsive-table-container::-webkit-scrollbar {
  height: 8px;
  width: 8px;
}

.responsive-table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.responsive-table-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.responsive-table-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
}
.loader-container p{
  font-size: 25px;
  color: gray;
}
.responsive-table {
  border-collapse: collapse;
  width: 100%;
  min-width: 1000px;
  font-size: 14px;
}

.responsive-table th,
.responsive-table td {
  border: 1px solid #ccc;
  padding: 8px 12px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px; /* Adjust as needed */
}

.responsive-table thead {
  background-color: #f3f3f3;
}

.responsive-table tr:hover {
  background-color: #f9f9f9;
}

/* Image style */
.table-image {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 4px;
}

/* Toggle Switch */
.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.moderator_approve_switch_by_admin {
  position: absolute;
  cursor: pointer;
  background-color: #ccc;
  border-radius: 20px;
  transition: 0.4s;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.moderator_approve_switch_by_admin:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  border-radius: 50%;
  transition: 0.4s;
}
input:checked + .moderator_approve_switch_by_admin {
  background-color: #4caf50;
}
input:checked + .moderator_approve_switch_by_admin:before {
  transform: translateX(20px);
}
.moderator_approve_switch_by_admin.round {
  border-radius: 20px;
}
.moderator_approve_switch_by_admin.round:before {
  border-radius: 50%;
}

/* Buttons */
.btn {
  padding: 4px 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}
.view-btn {
  background-color: #2196f3;
  color: white;
}
.delete-btn {
  background-color: #f44336;
  color: white;
}
.activate_button{
  border: none;
  background: transparent;
  outline: none !important;
  color: #4795DE;
  font-size: 15px;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/Modules/Moderator/NewCommunityRequest/index.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,qBAAqB,aAAa,YAAY;EAC9C,6BAA6B,MAAM,YAAY;AACjD;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB,EAAE,qBAAqB;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;AACA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".responsive-table-container {\r\n  width: 100%;\r\n  overflow: auto;\r\n  margin-top: 20px;\r\n  height: 50vh;\r\n  scrollbar-width: thin;            /* Firefox */\r\n  scrollbar-color: #888 #f1f1f1;     /* Firefox */\r\n}\r\n\r\n/* Chrome, Edge, Safari */\r\n.responsive-table-container::-webkit-scrollbar {\r\n  height: 8px;\r\n  width: 8px;\r\n}\r\n\r\n.responsive-table-container::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n}\r\n\r\n.responsive-table-container::-webkit-scrollbar-thumb {\r\n  background: #888;\r\n  border-radius: 4px;\r\n}\r\n\r\n.responsive-table-container::-webkit-scrollbar-thumb:hover {\r\n  background: #555;\r\n}\r\n\r\n.loader-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-top: 100px;\r\n}\r\n.loader-container p{\r\n  font-size: 25px;\r\n  color: gray;\r\n}\r\n.responsive-table {\r\n  border-collapse: collapse;\r\n  width: 100%;\r\n  min-width: 1000px;\r\n  font-size: 14px;\r\n}\r\n\r\n.responsive-table th,\r\n.responsive-table td {\r\n  border: 1px solid #ccc;\r\n  padding: 8px 12px;\r\n  text-align: left;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 180px; /* Adjust as needed */\r\n}\r\n\r\n.responsive-table thead {\r\n  background-color: #f3f3f3;\r\n}\r\n\r\n.responsive-table tr:hover {\r\n  background-color: #f9f9f9;\r\n}\r\n\r\n/* Image style */\r\n.table-image {\r\n  width: 40px;\r\n  height: 40px;\r\n  object-fit: cover;\r\n  border-radius: 4px;\r\n}\r\n\r\n/* Toggle Switch */\r\n.switch {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 40px;\r\n  height: 20px;\r\n}\r\n.switch input {\r\n  opacity: 0;\r\n  width: 0;\r\n  height: 0;\r\n}\r\n.moderator_approve_switch_by_admin {\r\n  position: absolute;\r\n  cursor: pointer;\r\n  background-color: #ccc;\r\n  border-radius: 20px;\r\n  transition: 0.4s;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n}\r\n.moderator_approve_switch_by_admin:before {\r\n  position: absolute;\r\n  content: \"\";\r\n  height: 14px;\r\n  width: 14px;\r\n  left: 3px;\r\n  bottom: 3px;\r\n  background-color: white;\r\n  border-radius: 50%;\r\n  transition: 0.4s;\r\n}\r\ninput:checked + .moderator_approve_switch_by_admin {\r\n  background-color: #4caf50;\r\n}\r\ninput:checked + .moderator_approve_switch_by_admin:before {\r\n  transform: translateX(20px);\r\n}\r\n.moderator_approve_switch_by_admin.round {\r\n  border-radius: 20px;\r\n}\r\n.moderator_approve_switch_by_admin.round:before {\r\n  border-radius: 50%;\r\n}\r\n\r\n/* Buttons */\r\n.btn {\r\n  padding: 4px 10px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n}\r\n.view-btn {\r\n  background-color: #2196f3;\r\n  color: white;\r\n}\r\n.delete-btn {\r\n  background-color: #f44336;\r\n  color: white;\r\n}\r\n.activate_button{\r\n  border: none;\r\n  background: transparent;\r\n  outline: none !important;\r\n  color: #4795DE;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
